export const getCheckoutAccessTypeLabel = (enabledHdPass?: boolean) =>
  enabledHdPass ? 'HD Pass' : 'Virtual ID';
